import enviro from 'enviro';
import 'usage-tracker-cdn';
import { getUrlParameter } from '../utils/url';
const enableUsageTrackerDebugInQA = () => {
  if (!enviro.isProd()) {
    enviro.setDebug('USAGE_TRACKER_JS');
  }
};
let tracker = null;
export const getTracker = appNamespace => {
  if (!tracker) {
    enableUsageTrackerDebugInQA();
    tracker = globalThis.createTracker({
      trackerName: appNamespace
    });
  }
  return {
    track: (...args) => {
      var _tracker;
      const uuid = getUrlParameter('uuid');
      const properties = uuid ? Object.assign({
        device_id: uuid
      }, args[1]) : args[1];
      return (_tracker = tracker) === null || _tracker === void 0 ? void 0 : _tracker.track(appNamespace, args[0], properties);
    }
  };
};